import { ContactAddressType } from '../common/ContactAddress.type'
import { GroupResponse } from '../common/GroupResponse'

export const contactGroupSerializer = (
  groupResponse: GroupResponse,
  contactAddresses: ContactAddressType[],
) => {
  return {
    id: groupResponse.id,
    groupName: groupResponse.groupName,
    groupAdmin: contactAddresses.filter(
      (address) => address.id === groupResponse.groupAdmin,
    )[0],
    members: contactAddresses.filter((address) =>
      groupResponse.members.includes(address.id),
    ),
    groupCategory: groupResponse.groupCategory,
    userId: groupResponse.userId
  }
}
